import { buildCurrentUserResponseOrEmpty, } from '../cross-session/CadPiiCurrentUserResponse';
import { buildRefCodeDataOrEmpty } from '../cross-session/RefCodeData';
import { buildWwwHeartbeatOrEmpty } from '../cross-session/WwwHeartbeatData';
import { buildContactFieldsFromEloquaData, buildContactFieldsOrEmpty, } from './ContactFields';
import { buildPersistedProgressiveProfileOrEmpty, } from './PersistedProgressiveProfile';
import { buildSignupDecorationOrUndefined } from './SignupDecoration';
const personalizationProfileVersion = 4;
export const buildPersonalizationProfileOrEmpty = (data) => {
    var _a, _b, _c, _d;
    if (!data) {
        return {
            contactFields: buildContactFieldsOrEmpty({}),
            currentUserData: buildCurrentUserResponseOrEmpty({}),
            heartbeatData: buildWwwHeartbeatOrEmpty({}),
            refCodeData: buildRefCodeDataOrEmpty({}),
            firstLandingPageDecoration: '',
            lastLandingPageDecoration: '',
            persistedProgressiveProfile: buildPersistedProgressiveProfileOrEmpty({}),
            signupDecoration: buildSignupDecorationOrUndefined({}),
            lastPushedDecorationsDateAdded: 0,
            lastPushedDecorations: {},
            lastUpdated: 0,
            hasLoggedIn: false,
            version: personalizationProfileVersion,
        };
    }
    return {
        contactFields: buildContactFieldsOrEmpty(data.contactFields),
        currentUserData: buildCurrentUserResponseOrEmpty(data.currentUserData),
        heartbeatData: buildWwwHeartbeatOrEmpty(data.heartbeatData),
        refCodeData: buildRefCodeDataOrEmpty(data.refCodeData),
        firstLandingPageDecoration: (_a = data.firstLandingPageDecoration) !== null && _a !== void 0 ? _a : '',
        lastLandingPageDecoration: (_b = data.lastLandingPageDecoration) !== null && _b !== void 0 ? _b : '',
        persistedProgressiveProfile: buildPersistedProgressiveProfileOrEmpty(data.persistedProgressiveProfile),
        signupDecoration: buildSignupDecorationOrUndefined(data.signupDecoration),
        lastPushedDecorations: data.lastPushedDecorations,
        lastPushedDecorationsDateAdded: (_c = data.lastPushedDecorationsDateAdded) !== null && _c !== void 0 ? _c : 0,
        lastUpdated: Date.now(),
        hasLoggedIn: (_d = data.hasLoggedIn) !== null && _d !== void 0 ? _d : false,
        version: personalizationProfileVersion,
    };
};
export const buildFromStoredOrCrossSession = ({ fromStorage, fromCrossSession, }) => {
    var _a;
    const { user: newUser, heartbeat: newHeartbeat } = fromCrossSession;
    const newContactFields = (newUser === null || newUser === void 0 ? void 0 : newUser.eloquaExtraData) ?
        buildContactFieldsFromEloquaData(newUser.eloquaExtraData)
        : fromStorage === null || fromStorage === void 0 ? void 0 : fromStorage.contactFields;
    const newCurrentUserData = (_a = newUser === null || newUser === void 0 ? void 0 : newUser.cadPiiCurrentUserResponse) !== null && _a !== void 0 ? _a : fromStorage === null || fromStorage === void 0 ? void 0 : fromStorage.currentUserData;
    const newSignupDecoration = (newUser === null || newUser === void 0 ? void 0 : newUser.signupDecoration) ?
        buildSignupDecorationOrUndefined(newUser.signupDecoration)
        : fromStorage === null || fromStorage === void 0 ? void 0 : fromStorage.signupDecoration;
    const newRefCodeData = (newUser === null || newUser === void 0 ? void 0 : newUser.refCodeData) ? buildRefCodeDataOrEmpty(newUser.refCodeData) : fromStorage === null || fromStorage === void 0 ? void 0 : fromStorage.refCodeData;
    const profileToStore = buildPersonalizationProfileOrEmpty(Object.assign(Object.assign({}, fromStorage), { contactFields: newContactFields, currentUserData: newCurrentUserData, signupDecoration: newSignupDecoration, refCodeData: newRefCodeData, heartbeatData: newHeartbeat !== null && newHeartbeat !== void 0 ? newHeartbeat : fromStorage === null || fromStorage === void 0 ? void 0 : fromStorage.heartbeatData }));
    return profileToStore;
};
